import AddBranch from "../../pages/AddBranch";
import AddMenu from "../../pages/AddMenu";
import Combo from "../../pages/Combo";
import CustomerList from "../../pages/CustomerList";
import Discount from "../../pages/Discount";
import LiveOrders from "../../pages/LiveOrders";
import OrderHistory from "../../pages/OrderHistory";
import ViewCombo from "../../pages/ViewCombo";
import ViewMenu2 from "../../pages/ViewMenu2";
import WaiterSingup from "../../pages/WaiterSingup";
import { Route } from "react-router-dom";
import Dashboard from "../../pages/Dashboard";
import Qr from "../../pages/Qr";
import WaiterPannelSingup from "../../pages/WaiterSingup";
import ProductBulkUpload from "../../pages/ProductBulkUpload";

export const Branchroutes = () => {
  return (
    <>
      <Route
        exact
        path="/waiter/pannel/signup"
        component={WaiterPannelSingup}
      ></Route>
      <Route path="/product/bulk/upload" component={ProductBulkUpload} />
      <Route path="/qr" component={Qr}></Route>
      <Route path="/liveorders" component={LiveOrders} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/branch/add" component={AddBranch} />
      <Route exact path="/item/add" component={AddMenu} />
      <Route exact path="/view/menu" component={ViewMenu2} />
      <Route path="/combo" component={Combo} />
      <Route path="/edit/combo/:id" component={Combo} />
      <Route exact path="/view/combo" component={ViewCombo} />
      <Route path="/edit/menu/:id" component={AddMenu} />
      <Route path="/discount" component={Discount} />
      <Route exact path="/order-history" component={OrderHistory} />
      <Route exact path="/customer-list" component={CustomerList} />
    </>
  );
};
export const navs = () => {};
